<app-toast-card heading="New version available" (closed)="dismiss.emit()">
    <p class="version-banner-text">Refresh the page to get the latest version.</p>
    <div class="version-banner-footer">
        <a [href]="versionUrl" target="_blank" class="badge env-badge {{ envBadgeClass() }}">{{ version }}</a>
        <button type="button" class="version-banner-refresh" (click)="refresh.emit()">Refresh</button>
    </div>
</app-toast-card>
